import { Controller } from "@hotwired/stimulus"

// Points the chat's provider typeahead at a new URL. The server replaces this element
// (a Turbo stream) when the chat's location changes, or once a search has placed the
// location (see ProviderSearchChat#autocomplete_location_params); connecting copies its
// URL onto the typeahead in the same form.
export default class extends Controller {
  static values = { url: String }

  connect() {
    const typeahead = this.element.closest("form")?.querySelector("[data-autocomplete-url-value]")
    if (typeahead && this.urlValue) typeahead.setAttribute("data-autocomplete-url-value", this.urlValue)
  }
}
